import React, { useState, useEffect } from 'react';

const TextTransitionEffect = ({ texts, interval = 4000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    const createPixelArray = (text) => {
      // Create a virtual canvas to measure text
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = '48px var(--font-display)';
      
      const pixels = [];
      const resolution = 4; // Lower number = higher resolution
      const width = Math.ceil(ctx.measureText(text).width);
      const height = 48; // Font size
      
      canvas.width = width;
      canvas.height = height;
      
      // Draw text and get pixel data
      ctx.font = '48px var(--font-display)';
      ctx.fillStyle = '#ffffff';
      ctx.fillText(text, 0, height * 0.8);
      const imageData = ctx.getImageData(0, 0, width, height);
      
      // Sample pixels at resolution intervals
      for (let y = 0; y < height; y += resolution) {
        for (let x = 0; x < width; x += resolution) {
          const alpha = imageData.data[((y * width + x) * 4) + 3];
          if (alpha > 0) {
            pixels.push({ x, y });
          }
        }
      }
      
      return pixels;
    };

    const scrambleText = async (finalText, duration = 1500, steps = 25) => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const finalWords = finalText.split(' ');
      const currentWords = displayText.split(' ');
      const stepTime = duration / steps;
      let step = 0;

      const scrambleStep = () => {
        if (step >= steps) {
          setDisplayText(finalText);
          setIsGlitching(false);
          return;
        }

        const progress = step / steps;
        const scrambled = finalWords.map((targetWord, wordIndex) => {
          const currentWord = currentWords[wordIndex] || '';
          let resultWord = '';

          for (let i = 0; i < targetWord.length; i++) {
            if (Math.random() > progress) {
              // Still scrambling this character
              resultWord += chars[Math.floor(Math.random() * chars.length)];
            } else {
              // Keep the final character
              resultWord += targetWord[i];
            }
          }
          return resultWord;
        }).join(' ');

        setDisplayText(scrambled);
        step++;
        requestAnimationFrame(scrambleStep);
      };

      setIsGlitching(true);
      scrambleStep();
    };

    const intervalId = setInterval(() => {
      const nextIndex = (currentIndex + 1) % texts.length;
      scrambleText(texts[nextIndex]);
      setCurrentIndex(nextIndex);
    }, interval);

    return () => clearInterval(intervalId);
  }, [currentIndex, texts, interval, displayText]);

  useEffect(() => {
    setDisplayText(texts[0]);
  }, [texts]);

  return (
    <div className="tech-text-container">
      <div className="text-content">
        {displayText.split(' ').map((word, wordIndex) => (
          <div key={wordIndex} className="word-wrapper">
            {word.split('').map((char, charIndex) => (
              <span
                key={charIndex}
                className="tech-char"
                style={{
                  animation: isGlitching ? 'pixelGlitch 0.2s ease' : 'none',
                  animationDelay: `${(charIndex * 15)}ms`,
                }}
              >
                {char}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextTransitionEffect;